









































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { UserPermission } from "@/shared/types";
import moment from "moment";
import VueRouter from "vue-router";
import { useSalesPersonStore } from "@/admin/store/salesPerson";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component
export default class SalesPersons extends Vue {
  $router: VueRouter;
  salesPersonStore = useSalesPersonStore();
  featureFlagStore = useFeatureFlagStore();
  rolePermissionsStore = useRolePermissionsStore();

  mounted (): void {
    this.salesPersonStore.getSalesPersons();
  }

  get hasEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
      ? this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalEmployerEdit)
      : true;
  }

  formatDate (date: string) {
    if (!date) {
      return "";
    }

    return moment(date).format("MM/DD/YYYY");
  }
}
